/**
 * 公共国际化资源 - 各端共享的词条
 * 各端可在此基础上扩展自己的词条
 *
 * @typedef {Object} SharedMessages
 * @property {object} zh-CN - 简体中文词条
 * @property {object} zh-TW - 繁体中文词条
 * @property {object} en-US - 英文词条
 * @property {object} ja - 日文词条
 */

import zhCN from './lang/zh-CN/index.mjs';
import zhTW from './lang/zh-TW/index.mjs';
import enUS from './lang/en-US/index.mjs';
import ja from './lang/ja/index.mjs';

/**
 * 各语言词条汇总
 * @type {SharedMessages}
 */
export const sharedMessages = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en-US': enUS,
  ja: ja,
};

export { zhCN, zhTW, enUS, ja };
